import { ENV } from 'gatsby-env-variables'

const wppUrl = 'https://api.whatsapp.com/send?phone='

const useWhatsAppJourney = ({ content } = {}) => {
  const whatsappNumber =
    ENV === 'prod'
      ? `${content?.whatsapp_number_prod || '551147658402'}`
      : `${content?.whatsapp_number_stg || '558007732340'}`

  const whatsappMessage =
    content?.whatsapp_message ||
    'Olá. Vim do Site de Renegociação, e gostaria de ver as propostas com a Recovery'

  const whatsappDataComplement = `${whatsappNumber}&text=${whatsappMessage}`

  const whatsappUrl = `${wppUrl}${whatsappDataComplement}`

  const handleClick = () => {
    window.open(whatsappUrl)
  }

  return { handleClick, whatsappUrl }
}

export default useWhatsAppJourney
